import { useEffect, useState } from 'react';
import { FeedEngine, EngineState } from '../connector/feed-engine/feed-engine';

// Live engine state for rendering. A bare getState() in a component body goes stale: state flips
// like LOADING->READY or LOADING->ERROR don't fire onFeedsChange (ERROR never delivers feed data at
// all), so components that only subscribe to feed data keep showing the state from their last
// render — e.g. an eternal spinner, or an empty library after a failed load.
export function useEngineState(engine: FeedEngine): EngineState {
    const [state, setState] = useState<EngineState>(() => engine.getState());
    useEffect(() => {
        setState(engine.getState());
        return engine.onStateChange(s => setState(s));
    }, [engine]);
    return state;
}
